var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar navbar-expand-md app-header"},[_c('b-navbar-brand',_vm._b({},"b-navbar-brand",_vm._d({},[_vm.linkType,_vm.homeLink])),[_c('svg-icon',{attrs:{"name":"logo"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }